import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { AdsApi } from '@core/apis/ads.api';
import { AuthType } from '@core/enums';
import { GetAdListCountResponse } from '@core/models/ad.model';
import { DestroyService } from '@core/services/destroy.service';
import { User } from '@sentry/angular-ivy';
import { Subject, finalize, takeUntil } from 'rxjs';
import { DeleteAccountComponent } from 'src/app/routes/auth/components/delete-account/delete-account.component';
import { ApiService } from '@shared/services/api.service';
import { AuthService } from '@shared/services/auth.service';
import { LocaleService } from '@shared/services/locale.service';
import { SnackService } from '@shared/services/snack.service';
import { UpdateMobileComponent } from '../../auth/components/update-mobile/update-mobile.component';
import { MatDialog } from '@angular/material/dialog';
import { DataTransferService } from '@shared/services/data-transfer.service';

@Component({
	selector: 'app-user-profile',
	templateUrl: './user-profile.component.html',
	styleUrls: ['./user-profile.component.scss'],
	providers: [DestroyService],
})
export class UserProfileComponent implements OnInit {
	constructor(
		private auth: AuthService,
		private snack: SnackService,
		private api: ApiService,
		private title: Title,
		public locale: LocaleService,
		private destroy: DestroyService,
		private adsApi: AdsApi,
		private matDialog: MatDialog,
		private dataTransfer: DataTransferService
	) {}

	loading: boolean = true;
	user: any = this.auth.user();
	phone: string = '';
	emailVerified: boolean;
	coverImage: string;
	images: { url: string | ArrayBuffer; progress: number; uploadID: string }[] = [];

	form: UntypedFormGroup = new UntypedFormGroup({
		name: new UntypedFormControl(null, [Validators.required]),
		email: new UntypedFormControl(null, [Validators.email]),
	});

	onSubmit() {
		this.loading = true;

		const formData: FormData = new FormData();
		formData.append('lang', this.locale.lang);
		formData.append('userID', this.user['userID']);
		formData.append('name', this.form.get('name').value);

		this.api.updateProfile(formData).subscribe((res) => {
			if (res['status'] === '1') {
				this.auth.login(
					this.user['userID'],
					this.form.get('name').value,
					this.user['phone'],
					this.user['verified'],
					this.user['token'],
					this.user['userType']
				);

				this.auth.setUser({ ...this.user, name: this.form.get('name').value });
				this.snack.open(this.locale.translations['user']['user-profile']['s16']);
			} else {
				this.snack.open(res['message']);
			}

			this.loading = false;
		});
	}

	onDelete() {
		this.loading = true;

		this.adsApi
			.getAdListCount()
			.pipe(finalize(() => (this.loading = false)))
			.subscribe((response: GetAdListCountResponse) => {
				this.user = { ...this.user, placedAds: response.count };

				this.matDialog.open(DeleteAccountComponent, {
					disableClose: true,
					maxWidth: '95vw',
					data: {
						authType: +this.user.placedAds > 0 ? AuthType.DELETE_ACCOUNT_HAS_ADS : AuthType.DELETE_ACCOUNT,
						user: this.user,
					},
				});
			});
	}
	// Open Upate Mobile dialog
	onUpdateMobile(): void {
		const phoneWithoutCoutryCode = this.user.phone;
		const phonePrefix = this.user.phonePrefix;
		const phoneWithCountryCode = `${phonePrefix}${phoneWithoutCoutryCode.substring(1)}`;

		this.auth.openAuthDialog({
			component: UpdateMobileComponent,
			phone: phoneWithoutCoutryCode,
			phonePrefix: phonePrefix,
			phoneWithCountryCode: phoneWithCountryCode,
			authType: AuthType.VERIFY_OLD_MOBILE,
		});
	}

	ngOnInit(): void {
		this.form.get('email').disable();
		this.title.setTitle(this.locale.translations['header']['n6'] + ' | ' + this.locale.translations['header']['n0']);

		const profileFormData: FormData = new FormData();
		profileFormData.append('lang', this.locale.lang);
		profileFormData.append('userID', this.user['userID']);

		this.auth.user$.pipe(takeUntil(this.destroy)).subscribe((user: User) => {
			this.user = user;

			if (this.user) {
				this.api.profile(profileFormData).subscribe((res) => {
					this.user = { ...this.user, name: res['response']['name'] };
					this.form.get('name').setValue(res['response']['name']);
					this.dataTransfer.emitProfileUpdate(this.user);
					this.user = { ...this.user, placedAds: res['response']['placedAds'] };

					// this.form.get('email').setValue(res['response']['altEmail'] ? res['response']['altEmail'] : res['response']['email']);
					this.phone = res['response']['phone'];

					if (res['response']['userType'] === '1') {
						this.form.get('name').disable();
					}
					// this.emailVerified = res['response']['emailVerified'] === '1';
					this.loading = false;
				});
			}
		});
	}
}
